import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCookieConsent } from '../../adapters/primary/CookieConsentContext';
import { initializeGA, trackPageView } from '../../configuration/analytics';

export const useAnalytics = () => {
  const location = useLocation();
  const { hasConsented } = useCookieConsent();

  useEffect(() => {
    // Only initialize GA if user has consented to cookies
    if (hasConsented) {
      initializeGA();
    }
  }, [hasConsented]);

  useEffect(() => {
    // Track page views only if user has consented
    if (hasConsented) {
      trackPageView(location.pathname);
    }
  }, [location.pathname, hasConsented]);

  return {
    isEnabled: hasConsented,
  };
};
